import { useEffect } from 'react';
import { LocalAudioTrack, LocalVideoTrack } from 'twilio-video';

import { isSafari } from 'features/video-conference/utils/ios15Workaround';

export function useRestartAudioTrackOnSafariBrowsers(
  localTracks: (LocalAudioTrack | LocalVideoTrack)[],
) {
  const audioTrack = localTracks.find((track) => track.kind === 'audio') as
    | LocalAudioTrack
    | undefined;
  const videoTrack = localTracks.find((track) => track.kind === 'video');

  useEffect(() => {
    if (!isSafari()) return () => {};
    const handleVisibilityChange = () => {
      if (audioTrack?.mediaStreamTrack.readyState === 'ended') {
        audioTrack.restart({}).catch(() => {});
      }
      if (videoTrack?.mediaStreamTrack.readyState === 'ended') {
        videoTrack.restart({}).catch(() => {});
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [audioTrack, videoTrack]);
}
